<template>
  <v-dialog
    :fullscreen="fullscreen"
    :scrollable="fullscreen"
    transition="dialog-bottom-transition"
    :value="isOpen"
    @input="handleChange"
    :width="width"
    persistent
  >
    <v-card>
      <v-card-title
        :class="{ 'py-2': fullscreen, 'px-3': fullscreen }"
        class="d-flex justify-space-between pb-2"
        primary-title
      >
        <h3><slot name="title" /></h3>
        <v-btn icon @click="$emit('close')" v-if="fullscreen">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <slot name="body" />
      <v-card-actions>
        <span class="base-dialog-actions">
          <slot name="actions" />
        </span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    isOpen: Boolean,
    width: {
      type: Number,
      required: false,
      default: 500
    },
    fullscreen: Boolean
  },
  methods: {
    handleChange(value) {
      this.$emit("updateDialog", value);
    }
  }
};
</script>

<style lang="scss"></style>
